// src/features/passwords/utils/clipboard.js

/**
 * Copy text to the system clipboard.
 * Supports modern navigator.clipboard API and a fallback for older browsers.
 *
 * @param {string} text - The text to copy
 * @param {Function} [onSuccess] - Optional callback when copy succeeds
 * @param {Function} [onError] - Optional callback when copy fails
 */
export async function copyToClipboard(text, onSuccess, onError) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        // Modern async clipboard API
        await navigator.clipboard.writeText(text);
        if (typeof onSuccess === 'function') onSuccess();
        return true;
      } else {
        // Fallback for insecure contexts / older browsers
        fallbackCopyTextToClipboard(text);
        if (typeof onSuccess === 'function') onSuccess();
        return true;
      }
    } catch (err) {
      console.error('Copy failed:', err);
      if (typeof onError === 'function') onError(err);
      return false;
    }
  }
  
  /**
   * Fallback implementation using a hidden textarea + execCommand('copy').
   */
  function fallbackCopyTextToClipboard(text) {
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
  
      // Avoid scrolling to bottom
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      textArea.style.left = '-9999px';
  
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
  
      document.execCommand('copy');
      document.body.removeChild(textArea);
    } catch (err) {
      console.error('Fallback copy failed:', err);
      throw err;
    }
  }
  